
interface EmptyPlansStateProps {
  loading: boolean;
}
export function EmptyPlansState({
  loading
}: EmptyPlansStateProps) {
  return <div className="text-center p-8 border rounded-lg">
      <h3 className="text-lg font-medium mb-2">Welcome to the Game Planner</h3>
      <p className="text-muted-foreground mb-4">
        Create interactive flow charts to visualize and plan your game strategies.
        {loading ? ' Loading your game plans...' : ' No game plans found. Create your first one!'}
      </p>
    </div>;
}